var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStroller = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "stroller_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#stroller_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M14.75 36.667a2.306 2.306 0 0 1-1.695-.695 2.305 2.305 0 0 1-.694-1.694c0-.667.232-1.232.694-1.695a2.306 2.306 0 0 1 1.695-.694c.667 0 1.232.231 1.695.694.462.463.694 1.028.694 1.695s-.232 1.231-.694 1.694a2.306 2.306 0 0 1-1.695.695Zm17.861 0a2.306 2.306 0 0 1-1.694-.695 2.304 2.304 0 0 1-.695-1.694c0-.667.232-1.232.695-1.695a2.306 2.306 0 0 1 1.694-.694c.667 0 1.232.231 1.694.694.464.463.695 1.028.695 1.695s-.231 1.231-.695 1.694a2.305 2.305 0 0 1-1.694.695ZM22.39 12.917l-6.444-7.75A13.767 13.767 0 0 1 19.222 4a15.85 15.85 0 0 1 3.445-.389c1.416 0 2.784.188 4.104.563 1.32.375 2.535.946 3.646 1.715l-8.028 7.028ZM12.389 30V9.222l-1.084-1.25c-.648-.75-1.16-1.248-1.534-1.493-.375-.245-.753-.368-1.132-.368-.796 0-1.417.306-1.861.917a3.369 3.369 0 0 0-.667 2.027H3.333c0-1.564.517-2.91 1.55-4.034 1.031-1.125 2.284-1.688 3.756-1.688.815 0 1.574.18 2.278.542.703.361 1.518 1.097 2.444 2.208L33.32 30H12.389Zm2.778-2.778h12.138L15.167 12.583v14.64Z"
}))));
export default SvgStroller;